import React from 'react';
import { classNames } from '../../utils/helpers';

const Badge = ({ 
  children, 
  variant = 'default', 
  size = 'md', 
  className = '',
  icon,
  ...props 
}) => {
  const variants = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-primary-100 text-primary-800',
    secondary: 'bg-secondary-100 text-secondary-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-amber-100 text-amber-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
    
    // Gradient variants
    'gradient-primary': 'bg-gradient-to-r from-primary-500 to-primary-600 text-white',
    'gradient-secondary': 'bg-gradient-to-r from-secondary-500 to-secondary-600 text-white',
    'gradient-success': 'bg-gradient-to-r from-green-500 to-green-600 text-white',
    'gradient-warning': 'bg-gradient-to-r from-amber-500 to-amber-600 text-white',
    'gradient-danger': 'bg-gradient-to-r from-red-500 to-red-600 text-white',
    
    // Status variants
    active: 'bg-green-100 text-green-800 ring-1 ring-green-600/20',
    inactive: 'bg-gray-100 text-gray-800 ring-1 ring-gray-600/20',
    pending: 'bg-amber-100 text-amber-800 ring-1 ring-amber-600/20',
  };

  const sizes = {
    xs: 'px-1.5 py-0.5 text-xs',
    sm: 'px-2 py-1 text-xs',
    md: 'px-2.5 py-0.5 text-sm',
    lg: 'px-3 py-1 text-sm',
    xl: 'px-4 py-1.5 text-base',
  };

  const classes = classNames(
    'badge',
    variants[variant],
    sizes[size],
    className
  );

  return (
    <span className={classes} {...props}>
      {icon && <span className="mr-1">{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;